module.exports = __webpack_public_path__ + "assets/img/2021591928118_.pic_hd.6d7982bd.jpg";